import React from "react";
import styles from './InformationCard.module.scss';
import PropTypes from "prop-types";

const InformationCard = ({ title, items = [], itemsPerRow = 4 }) => {
  return (
    <div className={styles.informationCard}>
      <h3>{title}</h3>
      <div className={styles.informationGrid} style={{ '--items-per-row': itemsPerRow }}>
        {items.map((item, index) => (
          <div key={index} className={styles.informationItem}>
            <label>{item.label}</label>
            <p>{item.value || '-'}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

InformationCard.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })),
  itemsPerRow: PropTypes.number,
};

export default InformationCard;
